require('./bootstrap');

window.Vue = require('vue').default;

Vue.component('gallery', require('./components/Gallery.vue').default);
Vue.component('cart-component', require('./components/CartComponent.vue').default);
Vue.component('cart-top-button', require('./components/CartTopButton.vue').default);

import {BootstrapVue} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.min.css';

Vue.use(BootstrapVue);

import VueImg from 'v-img';
import VueLazyLoad from 'vue-lazyload'
import Vuex from "vuex";
import {store} from './store/store';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert, {
    reverseButtons: true,
});

Vue.use(VueLazyLoad)
Vue.use(VueImg);
Vue.use(Vuex);
Vue.config.productionTip = false;

const app = new Vue({
    store,
    el: '#app',
});
